import React, { useEffect, useState } from 'react';
import { Button, Jumbotron, Table } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Footer from '~/Components/Footer';
import { Content, Header } from './styles';
import { loadRequest } from '~/store/modules/downloads/actions';
import FileDownload from '~/Components/FileDownload';
import Waiter from '~/Components/Waiter';

function DownloadsDiversos() {
	const dispatch = useDispatch();
	const { data: downloads, loading, error } = useSelector((e) => e.downloads);
	const [currentDownloads, setCurrentDownloads] = useState(null);

	useEffect(() => {
		if (!downloads) dispatch(loadRequest());
	}, [downloads, dispatch]);

	useEffect(() => {
		if (downloads) {
			const [current] = downloads.filter(
				(e) => e.key === 'mapoteca-diversos'
			);

			setCurrentDownloads(current);
		}
	}, [downloads]);

	return (
		<>
			<Content>
				<Header>Mapoteca Digital - Diversos</Header>
				{loading && <Waiter style={{ position: 'absolute' }} />}
				{!currentDownloads && !loading && !error && (
					<p>Esta categoria ainda não possui arquivos.</p>
				)}
				{currentDownloads && (
					<Jumbotron style={{ background: 'transparent' }}>
						<p className="lead">
							{!(
								!error &&
								!loading &&
								!currentDownloads.downloads[0]
							) &&
								currentDownloads.complement?.trim() &&
								currentDownloads.complement}
							{error &&
								'Houve num erro ao tentar carregar os documentos.'}
						</p>

						{error && (
							<p className="lead">
								<Button
									type="button"
									color="info"
									onClick={() => window.location.reload()}
								>
									Tentar novamente
								</Button>
							</p>
						)}

						<Table hover>
							<tbody>
								{currentDownloads.downloads.map((e, i) => (
									<FileDownload key={String(i)} data={e} />
								))}
							</tbody>
						</Table>
					</Jumbotron>
				)}
			</Content>
			<Footer />
		</>
	);
}

export default DownloadsDiversos;
